export default __webpack_public_path__ + "static/media/lungs_img_0010_Our_Lungs_And_Air_Quality.0afd42c3.png";